import React, { useEffect, useState } from 'react';
import API from '../../ApiService/ApiService';
import Context from './index';
import Widget from '../../Helpers/Widget';
import { Form } from 'antd';
const ExamsProvider = (props) => {
  const api = new API();
  const [formAddExam] = Form.useForm();
  const [formAddtional] = Form.useForm();
  const [examCategoryList, setExamCategoryList] = useState([]);
  const [examCategoryLoader, setExamCategoryLoader] = useState(false);
  const [examQMBankList, setExamQMBankList] = useState([]);
  const [examQMBankLoader, setExamQMBankLoader] = useState(false);
  const [examTableList, setExamTableList] = useState([]);
  const [examTableLoader, setExamTableLoader] = useState(false);
  const [statusUpdateLoader, setStatusUpdateLoader] = useState(false);
  const [subjectList, setSubjectList] = useState([]);
  const [tagsList, setTagsList] = useState([]);
  const [createExamPopup, setCreateExamPopup] = useState(false);
  const [addtionalSettingsLoader, setAddtionalSettingsLoader] = useState(false);
  const [bulkActionQbankExam, setBulkActionQbankExam] = useState([]);
  const [bulkActionQbankExamLoader, setBulkActionQbankExamLoader] = useState(false);
  const [bulkActionType, setBulkActionType] = useState(false);
  const [examTableFilter, setExamTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [examTableFilterSub, setExamTableFilterSub] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [examSubCategoryList, setExamSubCategoryList] = useState([]);
  const [examSubCategoryLoader, setExamSubCategoryLoader] = useState(false);
  const [examTable, setExamTable] = useState({
    name: "",
    page: 1,
    limit: 20,
    subject_id: [],
    topic_id: [],
    subcategory_id: [],
    topic_id_filter: "",
  });
  const [pageLoader, setPageLoader] = useState(false);
  const [addExamPopup, setAddExamPopup] = useState(false);
  const [addtionalSettings, setAddtionalSettings] = useState({
    subject: [],
    question_difficulty: "",
    adaptive_difficulty_level: "",
    tags: [],
  });
  const [pageTitle, setPageTitle] = useState({
    exam_name: "",
    category_name: "",
    subject_name: "",
    subcategory_name: "",
    topic_name: "",
  })
  const [getQListView, setGetQListView] = useState([]);
  const [getQListForm, setGetQListForm] = useState([]);
  const [publishStatus, setPublishStatus] = useState(0);
  const [createConfirmation, setCreateConfirmation] = useState(0);
  const [subjectValue, setSubjectValue] = useState('');
  const [tagsValue, setTagsValue] = useState('');
  const [onetimeCreateLoader, setOnetimeCreateLoader] = useState(false);
  const [questionListSaveView, setQuestionListSaveView] = useState([]);
  const [filterData, setFilterData] = useState([]);
  const [filterLoader, setFilterLoader] = useState(false);
  const [deletExamsLoader, setDeleteExamsLoader] = useState(false);
  const [videoTEList, setVideoTEList] = useState([]);
  const [videoTELoader, setVideoTELoader] = useState(false);
  //new question edit option
  const [newExamQuesEditPopup, setNewExamQuesEditPopup] = useState(false);
  const [newExamQuesEditID, setNewExamQuesEditID] = useState(null);
  const [newExamQuesEditLoader, setNewExamQuesEditLoader] = useState(false);
  const [newExamQuesSingleLoader, setNewExamQuesSingleLoader] = useState(false);
  const [newExamQuesSingleData, setNewExamQuesSingleData] = useState({});
  const [autoMcqWord, setAutoMcqWord] = useState(null);
  const [autoMcqLoader, setAutoMcqLoader] = useState(false);
  const [autoMcqPopup, setAutoMcqPopup] = useState(false);
  const [newQuestionEditForm] = Form.useForm();
  const [fetRatingData, setFetRatingData] = useState([]);
  const [fetRatingDataLoader, setFetRatingDataLoader] = useState(false);
  const [updateRatingData, setUpdateRatingData] = useState(null);
  const [updateRatingDataLoader, setUpdateRatingDataLoader] = useState(false);
  const [updateRatingPopup, setUpdateRatingPopup] = useState(null);
  //
  const [examTableListAttempt, setExamTableListAttempt] = useState([]);
  const [examTableAttemptLoader, setExamTableAttemptLoader] = useState(false);
  const [examTableAttempt, setExamTableAttempt] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const getRatingData = async (subcategory_id) => {
    setFetRatingDataLoader(true);
    await api.getAll("examsnew/get_star_rating_detailsv2",{
      subcategory_id
    }, (err, res) => {
      if (res?.data?.status === 200) {
        setFetRatingData(res?.data?.data);
      } else {
        setFetRatingData([]);
      }
      setFetRatingDataLoader(false);
    })
  }

  const getRatingDataUpdate = async () => {
    setUpdateRatingDataLoader(true);
    if (!updateRatingData) {
      Widget.showMessage("error", "Please select word file");
      setUpdateRatingDataLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", updateRatingData);
    await api.create("examsnew/get_star_rating_update", formData, (err, res) => {
      if (res?.data?.status === 200) {
        setUpdateRatingData(null)
        document.getElementById("excelFile11").value = "";
        setUpdateRatingDataLoader(false);
        setUpdateRatingPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setUpdateRatingDataLoader(false);
    })
  }

  const fetchNewExamQuesSingle = async () => {
    setNewExamQuesSingleLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getSingle("examsnew/newsinglequestion", newExamQuesEditID, (err, res) => {
        if (res?.data?.status === 200) {
          setNewExamQuesEditID(res?.data?.data?._id);
          setNewExamQuesSingleData(res?.data?.data);
          newQuestionEditForm.setFieldsValue(res?.data?.data);
        } else {

        }
        setNewExamQuesSingleLoader(false);
      })
  }
  const newUpdateExamQuesEditID = async (data, calback = null) => {
    const check_correct = data?.question_options?.filter(
      (item) => item?.is_correct === true
    );
    if (check_correct.length < 1) {
      Widget.showMessage("error", "Please select correct option");
      return;
    }
    if (data?.question_type === "single") {
      if (check_correct.length > 1) {
        Widget.showMessage("error", "Please select single correct option");
        return;
      }
    }
    const form_data = new FormData();
    form_data.append("question_name", data.question_name);
    form_data.append("question_type", data.question_type);
    form_data.append("explanation", data.explanation);
    form_data.append("reference", data.reference);
    data.question_options.forEach((item, i) => {
      form_data.append(`question_options[${i}][option]`, item.option);
      form_data.append(`question_options[${i}][is_correct]`, Boolean(item.is_correct));
      if (item._id) {
        form_data.append(`question_options[${i}][_id]`, item._id || null);
      }
    });
    setNewExamQuesEditLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.update("examsnew/neweditquestion", newExamQuesEditID, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          newQuestionEditForm.resetFields();
          calback && calback();
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setNewExamQuesEditLoader(false);
        setNewExamQuesEditPopup(false);
        setNewExamQuesEditID(null);
      })
  }

  const deleteExams = async (id, cid, sid = null) => {
    setDeleteExamsLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("examsnew/deleteexams", id, (err, res) => {
        if (res?.data?.status === 200) {
          fetchExamListTable(cid, sid);
          setDeleteExamsLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setDeleteExamsLoader(false);
        }
      })
  }
  const fetchExamCategoryList = async () => {
    setExamCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/categorylist', { ...examTableFilter }, (err, res) => {
        if (res) {
          setExamCategoryList(res?.data?.data);
        } else {
          setExamCategoryList([]);
        }
        setExamCategoryLoader(false);
      })
  };
  const fetchExamSubCategoryList = async (cid = null) => {
    setExamSubCategoryLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/subcategorylist', { ...examTableFilterSub, category_id: cid || null }, (err, res) => {
        if (res) {
          setExamSubCategoryList(res?.data?.data);
        } else {
          setExamSubCategoryList([]);
        }
        setExamSubCategoryLoader(false);
      })
  };

  const fetchQMBankList = async (cid) => {
    setExamQMBankLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/getqmbanklistv2', { topic_id: cid }, (err, res) => {
        if (res) {
          setExamQMBankList(res?.data?.data);
        } else {
          setExamQMBankList([]);
        }
        setExamQMBankLoader(false);
      })
  }

  const addExamBank = async (data, cid, sid = null,callback=null) => {
    if (!sid) {
      Widget.showMessage("error", "Please select subcategory");
      return;
    }
    localStorage.getItem("rxdx_admin_login") &&
      await api.create('examsnew/createv2', { ...data, topic_id: sid || null, questionbank_id: [data?.questionbank_id] }, (err, res) => {
        if (res?.data?.status === 200) {
          // fetchExamListTable(cid, sid);
          setAddExamPopup(false);
          formAddExam.resetFields();
          callback && callback(err, res);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      })
  }

  const fetchExamListTable = async (cid, sid = null) => {
    setExamTableLoader(true);
    const filter = {
      ...examTable, subject_id: examTable?.subject_id?.filter((item) => item !== "subject").join("|"),
      topic_id: examTable?.topic_id?.filter((item) => item !== "topic").join("|"),
      subcategory_id: examTable?.subcategory_id?.filter((item) => item !== "subcategory").join("|")
    };
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/examtablelistv2', { ...filter, category_id: cid, subcategory_id: sid || null }, (err, res) => {
        if (res) {
          setExamTableList(res?.data?.data);
        } else {
          setExamTableList([]);
        }
        setExamTableLoader(false);
      })
  };
  const fetchExamListAttemptTable = async (exam_id=null) => {
    setExamTableAttemptLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/examattempttrackv2', { ...examTableAttempt,exam_id:exam_id }, (err, res) => {
        if (res) {
          setExamTableListAttempt(res?.data?.data);
        } else {
          setExamTableListAttempt([]);
        }
        setExamTableAttemptLoader(false);
      })
  };
  const autoBulkUploadMcq = async (sub_id) => {
    setAutoMcqLoader(true);
    if (!autoMcqWord) {
      Widget.showMessage("error", "Please select word file");
      setAutoMcqLoader(false);
      return;
    }
    if (!sub_id) {
      Widget.showMessage("error", "Please select subject");
      setAutoMcqLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", autoMcqWord);
    formData.append("subcategory_id", sub_id);
    await api.create("examsnew/mcqbulkuploadtotal", formData, (err, res) => {
      if (res?.data?.status === 200) {
        setAutoMcqWord(null)
        document.getElementById("excelFile1").value = "";
        // fetchExamListTable(c_id, sub_id);
        setAutoMcqLoader(false);
        setAutoMcqPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setAutoMcqLoader(false);
    })
  }
  const fetchExamListTable1 = async (cid) => {
    const filter = {
      ...examTable, subject_id: examTable?.subject_id?.filter((item) => item !== "subject").join("|"),
      topic_id: examTable?.topic_id?.filter((item) => item !== "topic").join("|"),
      subcategory_id: examTable?.subcategory_id?.filter((item) => item !== "subcategory").join("|")
    };
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('examsnew/examtablelist', { ...filter, category_id: cid }, (err, res) => {
        if (res) {
          setExamTableList(res?.data?.data);
        } else {
          setExamTableList([]);
        }
      })
  };
  const examRowUpdate = async (data, cid) => {
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/rowupdate", { ids: data }, (err, res) => {
        if (res?.data?.status === 200) {
          fetchExamListTable1(cid);
        } else {

        }
      });
  };

  const addQuestionEaxmImage = async (data, cid, onClose, reSet, resetField) => {
    const form_data = new FormData();
    form_data.append("image", data?.image);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      (await api.update("examsnew/updateimage", data?.id, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          fetchExamListTable(cid);
          onClose();
          reSet();
          resetField();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
      }))
  }
  const statusUpdateExam = async (status, id, cid, sid = null) => {
    setStatusUpdateLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.update('examsnew/statusupdate', id, { status: status }, (err, res) => {
        if (res) {
          Widget.showMessage("success", res?.data?.message);
          fetchExamListTable(cid, sid);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setStatusUpdateLoader(false);
      })
  };

  const addNewSubject = async (name = null, reSetSub) => {
    if (!name) {
      Widget.showMessage("error", "Please enter subject name");
      return;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.create("attribute", { name: name, type: "subject" }, (err, res) => {
        if (res?.data?.status === 200) {
          reSetSub();
          fetchSubjectList();
          Widget.showMessage("success", res?.data?.message);
        }
      })
  }
  const addNewTags = async (name, reSetTags) => {
    if (!name) {
      Widget.showMessage("error", "Please enter tag name");
      return;
    }
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.create("attribute", { name: name, type: "tags" }, (err, res) => {
        if (res?.data?.status === 200) {
          reSetTags();
          fetchTagsList();
        }
      })
  }

  const fetchSubjectList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getAll("attribute/list", { type: "subject", status: 1 }, (err, res) => {
        if (res?.data?.status === 200) {
          setSubjectList(res?.data?.data?.map((e, i) => {
            return {
              label: e?.name,
              value: e?._id,
              key: i
            }
          }));
        }
      })
  }
  const fetchTagsList = async () => {
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getAll("attribute/list", { type: "tags", status: 1 }, (err, res) => {
        if (res?.data?.status === 200) {
          setTagsList(res?.data?.data?.map((e, i) => {
            return {
              label: e?.name,
              value: e?._id,
              key: i
            }
          }));
        }
      })
  }
  const fetchEaxmQuestionDetails = async (id) => {
    setPageLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.getSingle("examsnew/examquestionlist", id, (err, res) => {
        if (res?.data?.status === 200) {
          const data = res?.data?.data;
          setPageTitle({
            exam_name: data?.exams?.name,
            category_name: data?.exams?.category_id?.name,
            subject_name: data?.exams?.subject_id?.name,
            subcategory_name: data?.exams?.subcategory_id?.name,
            topic_name: data?.exams?.topic_id?.name,
          });
          formAddtional.setFieldsValue({
            ...data?.addtional_settings
          })
          setAddtionalSettings({ ...data?.addtional_settings });
          setGetQListView(data?.questions);
          setQuestionListSaveView(data?.question_list);
          setPublishStatus(data?.exams?.publish_status);
          setCreateConfirmation(data?.exams?.create_confirmation);
        }
        setPageLoader(false);
      })
  }

  const oneTimeCreateExam = async (eid) => {
    setOnetimeCreateLoader(true);
    if (getQListForm?.length === 0) {
      setOnetimeCreateLoader(false);
      Widget.showMessage("error", "Please add questions to create exam");
      return;
    }
    const form_data = new FormData();

    getQListForm.forEach((e, i) => {
      form_data.append(`question_list[${i}][question_name]`, e.question_name);
      form_data.append(`question_list[${i}][question_primary_id]`, e.question_primary_id);
      form_data.append(`question_list[${i}][question_order]`, e.question_order);
      form_data.append(`question_list[${i}][category_id]`, e.category_id);
      form_data.append(`question_list[${i}][subcategory_id]`, e.subcategory_id);
      form_data.append(`question_list[${i}][subject_id]`, e.subject_id);
      form_data.append(`question_list[${i}][topic_id]`, e.topic_id);
      form_data.append(`question_list[${i}][questionbank_id]`, e.questionbank_id);
      form_data.append(`question_list[${i}][iframe_url]`, e.iframe_url);
      form_data.append(`question_list[${i}][question_type]`, e.question_type);
      e.question_options?.forEach((option, index) => {
        form_data.append(`question_list[${i}][question_options][${index}][option]`, option.option);
        form_data.append(`question_list[${i}][question_options][${index}][is_correct]`, Boolean(option.is_correct));
        form_data.append(`question_list[${i}][question_options][${index}][_id]`, option._id);
      });
      form_data.append(`question_list[${i}][explanation]`, e.explanation);
      form_data.append(`question_list[${i}][reference]`, e.reference);
      form_data.append(`question_list[${i}][questionmaster_id]`, e._id);
    });
    localStorage.getItem("rxdx_admin_login") === "true" &&
      await api.update("examsnew/createexamupdate", eid, form_data, (err, res) => {
        if (res?.data?.status === 200) {
          setCreateExamPopup(false);
          saveAddtionalSettingsExam(eid);
          fetchEaxmQuestionDetails(eid);
          Widget.showMessage("success", res?.data?.message);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setOnetimeCreateLoader(false);
      })
  }
  const saveAddtionalSettingsExam = async (qid) => {
    setAddtionalSettingsLoader(true);
    localStorage.getItem("rxdx_admin_login") === "true" &&
      api.update("examsnew/addtionalsettings", qid, { ...addtionalSettings }, (err, res) => {
        if (res?.data?.status === 200) {
          if (publishStatus === 1) {
            Widget.showMessage("success", res?.data?.message);
          }
        } else {
          if (publishStatus === 1) {
            Widget.showMessage("error", err?.response?.data?.message);
          }
        }
        setAddtionalSettingsLoader(false);
      });
  }

  const scrollToTopView = (index) => {
    document.getElementById(`question_save_${index}`).scrollIntoView({ top: 0, behavior: 'smooth' });
  }

  const fetchFilterDropdown = async (cid) => {
    if (!cid) return;
    localStorage.getItem("rxdx_admin_login") === "true" &&
      setFilterLoader(true);
    await api.getAll("examsnew/filterdropdown", { category_id: cid }, (err, res) => {
      if (res?.data?.status === 200) {
        setFilterData(res?.data?.data);
      } else {
        setFilterData([]);
      }
      setFilterLoader(false);
    })
  }

  const fetchVideoTEList = async () => {
    setVideoTELoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("examsnew/examtopicdropdown", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoTEList(res?.data?.data);
          setVideoTELoader(false);
        } else {
          setVideoTEList([]);
          setVideoTELoader(false);
        }
      });
  }
  //exam bulk action
  const bulkActionExams = async (ids = [], action = null, cid = null, sid = null,callback=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionQbankExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          cid && sid && fetchExamListTable(cid, sid);
          callback && callback(err, res);
          setBulkActionQbankExam([]);
          setBulkActionQbankExamLoader(false);
        } else {
          setBulkActionQbankExamLoader(false);
        }
      });
  }

  return (
    <Context.Provider
      value={{
        ...props,
        examCategoryList,
        examCategoryLoader,
        fetchExamCategoryList,
        examTableFilter,
        setExamTableFilter,
        addExamPopup,
        setAddExamPopup,
        formAddExam,
        fetchQMBankList,
        examQMBankList,
        examQMBankLoader,
        addExamBank,
        examTable,
        setExamTable,
        fetchExamListTable,
        examTableList,
        setExamTableList,
        examTableLoader,
        setExamTableLoader,
        addQuestionEaxmImage,
        statusUpdateLoader,
        setStatusUpdateLoader,
        statusUpdateExam,
        addtionalSettings,
        setAddtionalSettings,
        formAddtional,
        subjectValue,
        setSubjectValue,
        tagsValue,
        setTagsValue,
        addNewSubject,
        addNewTags,
        subjectList,
        setSubjectList,
        tagsList,
        setTagsList,
        fetchSubjectList,
        fetchTagsList,
        fetchEaxmQuestionDetails,
        pageLoader,
        setPageLoader,
        pageTitle,
        setPageTitle,
        getQListView,
        setGetQListView,
        getQListForm,
        setGetQListForm,
        publishStatus,
        setPublishStatus,
        createConfirmation,
        setCreateConfirmation,
        createExamPopup,
        setCreateExamPopup,
        onetimeCreateLoader,
        setOnetimeCreateLoader,
        oneTimeCreateExam,
        saveAddtionalSettingsExam,
        questionListSaveView,
        setQuestionListSaveView,
        scrollToTopView,
        addtionalSettingsLoader,
        setAddtionalSettingsLoader,
        filterData, setFilterData,
        fetchFilterDropdown,
        filterLoader, setFilterLoader,
        deletExamsLoader,
        deleteExams,
        videoTEList, setVideoTEList,
        videoTELoader, setVideoTELoader,
        fetchVideoTEList,
        examRowUpdate,
        newExamQuesEditID, setNewExamQuesEditID,
        newExamQuesEditLoader, setNewExamQuesEditLoader,
        newUpdateExamQuesEditID,
        newExamQuesEditPopup, setNewExamQuesEditPopup,
        newQuestionEditForm,
        newExamQuesSingleLoader, setNewExamQuesSingleLoader,
        newExamQuesSingleData, setNewExamQuesSingleData,
        fetchNewExamQuesSingle,
        examSubCategoryList,
        setExamSubCategoryList,
        examSubCategoryLoader,
        setExamSubCategoryLoader,
        fetchExamSubCategoryList,
        examTableFilterSub,
        setExamTableFilterSub,
        autoMcqWord, setAutoMcqWord,
        autoMcqLoader, setAutoMcqLoader,
        autoMcqPopup, setAutoMcqPopup,
        autoBulkUploadMcq,
        bulkActionQbankExam, setBulkActionQbankExam,
        bulkActionQbankExamLoader, setBulkActionQbankExamLoader,
        bulkActionType, setBulkActionType,
        bulkActionExams,
        //new
        fetRatingData, setFetRatingData,
        fetRatingDataLoader, setFetRatingDataLoader,
        updateRatingData, setUpdateRatingData,
        updateRatingDataLoader, setUpdateRatingDataLoader,
        getRatingData,
        updateRatingPopup, setUpdateRatingPopup,
        getRatingDataUpdate,
        //
        examTableListAttempt, setExamTableListAttempt,
        examTableAttemptLoader, setExamTableAttemptLoader,
        examTableAttempt, setExamTableAttempt,
        fetchExamListAttemptTable,
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default ExamsProvider;
